import React, { createContext, ReactNode, useContext } from "react";
import { sessionSettingsCompliance } from "../utils/compliance";
import { useStorageWithConsent } from "./useStorageWithConsent";

export type Device = "computer" | "iOS" | "android";

export interface SessionSettings {
  device: Device | undefined;
  getCodingDevicePrompt: boolean;
  gettingStartedReadyPrompt: boolean;
}

export const defaultSessionSettings: SessionSettings = {
  device: undefined,
  getCodingDevicePrompt: false,
  gettingStartedReadyPrompt: false
};

const defaultValueFactory = () => defaultSessionSettings;

export type SessionSettingsContextValue = [
  SessionSettings | undefined,
  (sessionSettings: SessionSettings) => void
];

const SessionSettingsContext = createContext<
  SessionSettingsContextValue | undefined
>(undefined);

export const useSessionSettings = (): SessionSettingsContextValue => {
  const sessionSettings = useContext(SessionSettingsContext);
  if (!sessionSettings) {
    throw new Error("Missing provider");
  }
  return sessionSettings;
};

const SessionSettingsProvider = ({ children }: { children: ReactNode }) => {
  const sessionSettings = useStorageWithConsent<SessionSettings>(
    sessionSettingsCompliance,
    defaultValueFactory
  );
  return (
    <SessionSettingsContext.Provider value={sessionSettings}>
      {children}
    </SessionSettingsContext.Provider>
  );
};

export default SessionSettingsProvider;
